import { Modal, Button } from 'gatorcomponents';
import React from 'react';
import * as Styles from './ConfirmModal.styles';

const ConfirmModal = ({
  onCloseModal,
  title,
  description,
  buttonsProps = [],
}) => (
  <Modal onClose={onCloseModal} noHeader testId="confirm-modal" mobileMaxHeight="372px">
    <Styles.Wrapper>
      <Styles.Title>{title}</Styles.Title>
      <Styles.Description dangerouslySetInnerHTML={{ __html: description }} />
      <Styles.ButtonsContainer>
        {buttonsProps.map(button => (
          <Button
            key={button.testId}
            testId={button.testId}
            variant={button.variant}
            label={button.label}
            size={button.size}
            onClick={button.onClick}
          />
        ))}
      </Styles.ButtonsContainer>
    </Styles.Wrapper>
  </Modal>
);


export default ConfirmModal;
